<template>
  <div>
    <b-modal
      title="NOVO USUÁRIO DASHBOARD MONITORAMENTO"
      id="new_user_dashboard_monitoring"
      size="lg"
      no-close-on-backdrop
      hide-footer
      @show="evOnShow"
      @shown="evOnShown"
    >
      <b-overlay :show="loading" opacity="0.99">
        <form @submit.prevent="evOnSubmit">
          <div class="row">
            <div class="col-md-12">
              <LabelRequiredField label="Nome" />
              <input
                type="text"
                ref="autofocus"
                v-model="name"
                class="form-control"
              />
            </div>

            <div class="col-md-4">
              <LabelRequiredField label="Grupo" />
              <select v-model="user_group_id" class="form-control">
                <option value>SELECIONE...</option>
                <option
                  v-for="value in userGroups"
                  :key="value.id"
                  :value="value.id"
                >
                  {{ String(value.name).toUpperCase() }}
                </option>
              </select>
            </div>

            <div class="col-md-4">
              <LabelRequiredField label="Perfil" />
              <select v-model="user_profile_id" class="form-control">
                <option value>SELECIONE...</option>
                <option
                  v-for="value in userProfiles"
                  :key="value.id"
                  :value="value.id"
                >
                  {{ String(value.name).toUpperCase() }}
                </option>
              </select>
            </div>

            <div class="col-md-4">
              <LabelRequiredField label="Status" />
              <select v-model="status_type_id" class="form-control">
                <option value>SELECIONE...</option>
                <option
                  v-for="value in statusTypes"
                  :key="value.id"
                  :value="value.id"
                >
                  {{ String(value.name).toUpperCase() }}
                </option>
              </select>
            </div>

            <div class="col-md-4">
              <LabelRequiredField label="E-mail" />
              <input type="email" v-model="email" class="form-control" />
            </div>

            <div class="col-md-4">
              <label for="password">
                Senha
                <strong>
                  <code>*</code>
                </strong>
              </label>
              <b-input-password v-model="password" />
            </div>

            <div class="col-md-4">
              <LabelRequiredField label="Confirmação da senha" />
              <b-input-password v-model="confirm_password" />
            </div>

            <div class="col-md-12">
              <WarningRequiredFields />
              <ErrorsMessages :errors="errors" />
            </div>

            <div class="col-md-12 text-right">
              <v-btn type="submit" class="btn-add">
                <i class="fas fa-check mr-2 text-twenty"></i>
                SALVAR
              </v-btn>
            </div>
          </div>
        </form>
      </b-overlay>
    </b-modal>
  </div>
</template>

<script>
import LabelRequiredField from "../Components/LabelRequiredField";
import WarningRequiredFields from "../Components/WarningRequiredFields";
import ErrorsMessages from "../Components/ErrorsMessages";
import BInputPassword from "../Components/BInputPassword.vue";

import api from "../../services/api";

import toast from "../../lib/ToastNotification";

export default {
  name: "NewUserDashboardMonitoring",
  components: {
    LabelRequiredField,
    WarningRequiredFields,
    ErrorsMessages,
    BInputPassword,
  },
  data() {
    return {
      errors: [],
      loading: false,

      name: "",

      email: "",

      password: "",
      confirm_password: "",

      user_group_id: "",
      userGroups: [],

      user_profile_id: "",
      userProfiles: [],

      status_type_id: "",
      statusTypes: [],
    };
  },
  created() {
    this.setup();
  },
  methods: {
    async setup() {
      if (this.errors.length == 0) await this.getStatusUsers();
      if (this.errors.length == 0) await this.getUserGroups();
      if (this.errors.length == 0) await this.getUserProfiles();
    },

    async evOnShow() {
      this.errors = [];
      this.loading = false;
      this.name = "";
      this.email = "";
      this.password = "";
      this.confirm_password = "";
      this.user_group_id = "";
      this.user_profile_id = "";
      this.status_type_id = "";
    },

    async evOnShown() {
      this.$refs.autofocus.focus();
    },

    async evOnSubmit() {
      try {
        this.loading = true;

        let {
          status_type_id,
          user_group_id,
          user_profile_id,
          name,
          email,
          password,
          confirm_password,
        } = this;

        let params = {
          status_type_id,
          user_group_id,
          user_profile_id,
          name,
          email,
          password,
          confirm_password,
        };

        const response = await api.post(
          "/rest-home/user/dashboard-monitoring",
          params
        );

        const { error, errors, message } = response.data;

        if (!error) {
          this.$bvModal.hide("new_user_dashboard_monitoring");
          toast(message, "success");
          this.$emit("created");
        } else {
          this.errors = errors;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    /** retrievers */
    async getStatusUsers() {
      try {
        const { rest_home_id } = this;

        let params = {
          rest_home_id,
          type: "USUARIO",
        };

        const response = await api.get("/rest-home/type/status/all", {
          params,
        });

        const { error, errors, status } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.statusTypes = status;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async getUserGroups() {
      try {
        const response = await api.get("/rest-home/groups");

        const { error, errors, groups } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.userGroups = groups;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async getUserProfiles() {
      try {
        const response = await api.get("/rest-home/profiles");

        const { error, errors, profiles } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.userProfiles = profiles;
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style></style>
